import * as React from "react";
import { LegalPage } from "@/components/LegalPage";
import { IMPRINT_SECTIONS } from "@/constants/imprint";

export default function Impressum() {
  return <LegalPage title="Impressum" sections={IMPRINT_SECTIONS} />;
}
